import React from 'react';
import UIUXHero from './components/UIUXHero';
import UIUXServices from './components/UIUXServices';
import UIUXProcess from './components/UIUXProcess';
import UIUXTechStack from './components/UIUXTechStack';
import WhyChooseUs from '../SoftwareDevelopment/components/WhyChooseUs';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';

const UIUXDesign = () => {
  return (
    <div className="uiux-design-page">
      <UIUXHero />
      <UIUXServices />
      <UIUXProcess />
      <UIUXTechStack />
      <WhyChooseUs />
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default UIUXDesign; 